export const SET_WEATHER_FORECAST = 'SET_WEATHER_FORECAST'
export const SET_SOLAR_TIME = 'SET_SOLAR_TIME'
export const SET_HEALTH_WEATHER = 'SET_HEALTH_WEATHER'
export const SET_WEEKLY_WEATHER = 'SET_WEEKLY_WEATHER'
export const SET_TYPHOON_LIST = 'SET_TYPHOON_LIST'
export const SET_TYPHOON_INFORMATION = 'SET_TYPHOON_INFORMATION'
